<template>
  <img :src="logoSrc" :class="classes">
</template>
<script>
export default {
  props: {
    logoType: {
      type: String
    },
    greyscale: {
      type: Boolean,
      default: false
    },
    lowOpacity: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classes: []
    }
  },
  computed: {
    shouldNotShowLogoYet() {
      // If the organization plan is not set and we're not on the login screen don't show logo.
      // Otherwise if plan is Talent the normal Leads logo will show for 1 second before it changes to Talent logo.
      // On login screen always show logo.
      let isLoginPage = this.$route.name === 'login'
      let planExists  = !!this.$store.getters.getCurrentOrganizationPlan
      return !isLoginPage && !planExists
    },
    currentPlanIsTalent() {
      return this.$store.getters.getCurrentPlanIsTalent
    },
    logoSrc() {
      if (this.shouldNotShowLogoYet) { return }
      let path = undefined
      if (this.currentPlanIsTalent) {
        path = "talents_logo"
      } else {
        path = "logo_sign"
      }
      if (this.logoType === "login") {
        path += "_login"
      }
      if (this.logoType === "grey") {
        path += "_grey"
      }
      return require(`@/assets/${path}.svg`)
    }
  }
}
</script>
<style lang="scss" scoped>
img  {
    vertical-align: text-bottom;
}
</style>



// WEBPACK FOOTER //
// Logo.vue?7a10423e